import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

export const createAddress = createAsyncThunk(
  "userAddress/createAddress",
  async (addressData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${BASE_URL}/myData/address`,
        addressData,
        {
          headers: { token: token },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to create address",
      );
    }
  },
);

export const deleteAddressById = createAsyncThunk(
  "userAddress/deleteAddressById",
  async (addressId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      const response = await axios.delete(
        `${BASE_URL}/myData/address/${addressId}`,
        {
          headers: { token: token },
        },
      );
      return { addressId, status: response.data.status };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete address",
      );
    }
  },
);
// get data user
export const getAddressesByUserId = createAsyncThunk(
  "userAddress/getAddressesByUserId",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");

      if (!token) {
        console.error("Access token not found");
        throw new Error("Access token not found");
      }
      // console.log(token)
      const response = await axios.get(`${BASE_URL}/myData`, {
        headers: { token: token },
      });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Invalid response format");
      }
      // console.log(response.data.data)
      return response.data.data;
    } catch (error) {
      // console.log(error);
      // localStorage.removeItem("accessToken");
      // localStorage.removeItem("notificationUnread");
      // localStorage.removeItem("accessToken");
      console.error("Error fetching addresses:", error);
      return rejectWithValue(error.response?.data || "No addresses found");
    }
  },
);

export const updateUserAddress = createAsyncThunk(
  "userAddress/updateUserAddress",
  async ({ addressId, updatedData }, { rejectWithValue }) => {
    try {
      // console.log(addressId)
      // console.log(updatedData)
      const token = localStorage.getItem("accessToken");
      if (!token) {
        console.error("Access token not found");
        throw new Error("Access token not found");
      }

      const response = await axios.put(
        `${BASE_URL}/myData/address/${addressId}`,
        { updateData: updatedData },
        {
          headers: { token: token },
        },
      );

      // console.log("Update Response:", response.data);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Invalid response format");
      }

      return response.data;
    } catch (error) {
      console.error("Error updating address:", error);
      return rejectWithValue(
        error.response?.data || "Failed to update address",
      );
    }
  },
);

// update name & phone
export const updateUserById = createAsyncThunk(
  "userAddress/updateUserById",
  async ({ userId, updatedData }, { rejectWithValue }) => {
    // console.log(userId, updatedData)
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      // console.log(token)
      const response = await axios.put(
        `${BASE_URL}/user/${userId}`,
        updatedData,
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(
        "Update user error:",
        error.response?.data || error.message,
      );
      return rejectWithValue(error.response?.data || "Failed to update user");
    }
  },
);

// update Password
export const updateUserPassword = createAsyncThunk(
  "userAddress/updateUserPassword",
  async ({ oldPassword, newPassword }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      const response = await axios.post(
        `${BASE_URL}/auth/changePassword`,
        { oldPassword, newPassword },
        {
          headers: { token: token },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update password",
      );
    }
  },
);

// Add Phone Number
export const AddPhoneNumber = createAsyncThunk(
  "userAddress/AddPhoneNumber",
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(`${BASE_URL}/user/addPhone`, payload, {
        headers: { token: token },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to create address",
      );
    }
  },
);

// Slice
const userAddressSlice = createSlice({
  name: "userAddress",
  initialState: {
    addresses: [],
    currentAddress: null,
    loading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    // Create Address
    builder.addCase(createAddress.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createAddress.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = "Address created successfully!";
      state.addresses.user.addresses.push(action.payload);
    });
    builder.addCase(createAddress.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Delete Address by ID
    builder.addCase(deleteAddressById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteAddressById.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = "Address deleted successfully!";
    });
    builder.addCase(deleteAddressById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Get Addresses by User ID
    builder.addCase(getAddressesByUserId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAddressesByUserId.fulfilled, (state, action) => {
      state.loading = false;
      state.addresses = action.payload;
    });
    builder.addCase(getAddressesByUserId.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // Get data by User ID for (update name & phone)
    builder.addCase(updateUserById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateUserById.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = "User updated successfully!";

      // Update data directly
      state.addresses = action.payload;
    });
    builder.addCase(updateUserById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Get data by User ID for (update password)
    builder.addCase(updateUserPassword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateUserPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = "Password updated successfully!";
    });
    builder.addCase(updateUserPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Add Phone Number
    builder.addCase(AddPhoneNumber.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(AddPhoneNumber.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = "Address created successfully!";
      // state.addresses.push(action.payload);
    });
    builder.addCase(AddPhoneNumber.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Export actions and reducer
export const { clearError, clearSuccessMessage } = userAddressSlice.actions;
export default userAddressSlice.reducer;
